import { TranslationKeys } from '~/hooks/useLocalization';

const DECLINE_KEYS = new Map<string, TranslationKeys>([
  ['Unknown', TranslationKeys.PAYMENT_DECLINE_UNKNOWN],
  ['InvalidRequest', TranslationKeys.PAYMENT_DECLINE_INVALID_REQUEST],
  ['InvalidAmount', TranslationKeys.PAYMENT_DECLINE_INVALID_AMOUNT],
  ['InvalidValue', TranslationKeys.PAYMENT_DECLINE_INVALID_VALUE],
  ['Unauthorized', TranslationKeys.PAYMENT_DECLINE_UNAUTHORIZED],
  ['Forbidden', TranslationKeys.PAYMENT_DECLINE_FORBIDDEN],
  ['DuplicateRequest', TranslationKeys.PAYMENT_DECLINE_DUPLICATE_REQUEST],
  ['Timeout', TranslationKeys.PAYMENT_DECLINE_TIMEOUT],
  ['ProviderUnavailable', TranslationKeys.PAYMENT_DECLINE_PROVIDER_UNAVAILABLE],
  ['ProviderError', TranslationKeys.PAYMENT_DECLINE_PROVIDER_ERROR],
  ['ProcessingLimitExceeded', TranslationKeys.PAYMENT_DECLINE_PROCESSING_LIMIT_EXCEEDED],
  ['PaymentMethodLimitExceeded', TranslationKeys.PAYMENT_DECLINE_PAYMENT_METHOD_LIMIT_EXCEEDED],
  ['PaymentMethodVerificationFailed', TranslationKeys.PAYMENT_DECLINE_PAYMENT_METHOD_VERIFICATION_FAILED],
  ['PaymentMethodHolderMismatch', TranslationKeys.PAYMENT_DECLINE_PAYMENT_METHOD_HOLDER_MISMATCH],
  ['CollectDeclined', TranslationKeys.PAYMENT_DECLINE_COLLECT_DECLINED],
  ['CollectInsufficientFunds', TranslationKeys.PAYMENT_DECLINE_COLLECT_INSUFFICIENT_FUNDS],
  ['CollectMethodInvalid', TranslationKeys.PAYMENT_DECLINE_COLLECT_METHOD_INVALID],
  ['CollectMethodExpired', TranslationKeys.PAYMENT_DECLINE_COLLECT_METHOD_EXPIRED],
  ['CollectRestricted', TranslationKeys.PAYMENT_DECLINE_COLLECT_RESTRICTED],
  ['CollectRequiresAction', TranslationKeys.PAYMENT_DECLINE_COLLECT_REQUIRES_ACTION],
  ['KycRequired', TranslationKeys.PAYMENT_DECLINE_KYC_REQUIRED],
  ['KycFailed', TranslationKeys.PAYMENT_DECLINE_KYC_FAILED],
  ['RiskRejected', TranslationKeys.PAYMENT_DECLINE_RISK_REJECTED],
  ['SanctionRestricted', TranslationKeys.PAYMENT_DECLINE_SANCTION_RESTRICTED],
  ['InternalError', TranslationKeys.PAYMENT_DECLINE_INTERNAL_ERROR],
]);

export const declineKeyFor = (code?: string | null): TranslationKeys | undefined => (code ? DECLINE_KEYS.get(code) : undefined);
